<template>
  <div>
    <ProjectReportsParentBar />
    <router-view ></router-view>
  </div>
</template>

<script>
import ProjectReportsParentBar from "@/components/ProjectReportsParentBar.component.vue";
export default {
  data(){
    return {
      projectId: this.$route.params.projectId,
    }
  },
  computed: {
    admins() {
      return this.$store.getters["admin/getByProjectId"](this.projectId);
    },
    employees() {
      return this.$store.getters["employee/getByProjectId"](this.projectId);
    }
  },
  components: {
    ProjectReportsParentBar,
  },
  created(){
    if(!(this.admins?.length || this.employees?.find(d => d.enableViewAccountingProject || d.enableViewReportsProject))){
      this.$router.push(`/notFound`);
    }
  },
  mounted() {
    this.setProjectId(this.$route.params.projectId);
  },
  methods: {
    setProjectId(projectId) {
      this.$store.commit("markets/setProjectId", {
        projectId: projectId,
      });
    },
  },
};
</script>

<style>
</style>